(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chat-widget-javascript"] && !Shopify.designMode) return;
  try {
    var sectionEl = document.querySelector('[data-chat-widget-section]');
  if (!sectionEl) return;

  var configScript = sectionEl.querySelector('[data-chat-config]');
  if (!configScript) return;

  var config;
  try {
    config = JSON.parse(configScript.textContent.trim());
  } catch (e) {
    return;
  }

  if (!config.enable) return;

  var LHC_API = window.LHC_API || {};

  var baseArgs = {
    mode: 'widget',
    lhc_base_url: '//' + config.chat_domain + '/index.php/',
    wheight: 450,
    wwidth: 350,
    pheight: 520,
    pwidth: 500,
    domain: config.store_domain,
    leaveamessage: true,
    department: [config.department_id],
    theme: config.theme,
    survey: 1,
    check_messages: false,
    proactive: config.proactive
  };

  LHC_API.args = Object.assign({}, LHC_API.args || {}, baseArgs);
  window.LHC_API = LHC_API;

  // Optional expert activator in another section
  var expertActivator = document.querySelector('[data-expert-chat-activator="true"]');
  var expertTemplate = sectionEl.querySelector('[data-expert-activator-template]');
  var hasExpertActivator = !!expertActivator;

  /** @param {'1' | '2' | '3'} department */
  function openWidgetWithDepartment(department) {
    if (!window.$_LHC || !window.$_LHC.eventListener) return;
    LHC_API.args.department = [department];

    window.$_LHC.attributes.department = [department];

    // Reload widget so new start chat form settings will be picked up
    window.$_LHC.eventListener.emitEvent('reloadWidget');

      window.$_LHC.eventListener.emitEvent('showWidget');
  }

  function openWidget() {
    if (!window.$_LHC || !window.$_LHC.eventListener) return;
    window.$_LHC.eventListener.emitEvent('showWidget');
  }

  if (hasExpertActivator && expertTemplate) {
    // Custom callback passed to LHC to inject our expert widget when online
    var customCb = function (loadcb) {
      var clone = document.importNode(expertTemplate.content, true);
      loadcb.onlineStatus.subscribe(() => {
        if (!expertActivator.contains(clone)) {
          expertActivator.appendChild(clone);

          var clickable = expertActivator.querySelector('[data-expert-click]');
          if (clickable) {
            if (config.use_expert_department && config.expert_department_id) {
              clickable.addEventListener('click', () => {openWidgetWithDepartment(config.expert_department_id)});
            } else {
              clickable.addEventListener('click', openWidget);
            }
          }
        }
      });
    };

    LHC_API.args.loadcb = customCb;

    if (config.hide_status) {
      LHC_API.args.position = 'api';
      LHC_API.args.hide_status = true;
    }

    window.LHC_API = LHC_API;
  }

  var po = document.createElement('script');
  po.type = 'text/javascript';
  po.setAttribute('crossorigin', 'anonymous');
  po.async = true;

  var date = new Date();
  po.src =
    '//' +
    config.chat_domain +
    '/design/defaulttheme/js/widgetv2/index.js?' +
    ('' + date.getFullYear() + date.getMonth() + date.getDate());

  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(po, s);
  } catch(e) { console.error(e); }
})();

})();
